import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Cleave from 'cleave.js/react'
import ValidationUtil from './utils/ValidationUtil'

const types = [
  'ssn',
  'ein',
  'shortDate',
  'standardDate',
  'zip',
  'number'
]
const cleaveOptions = {
  ein: {
    blocks: [2, 7],
    delimiter: '-',
    numericOnly: true,
    delimiterLazyShow: true
  },
  ssn: {
    blocks: [3, 2, 4],
    delimiter: '-',
    numericOnly: true,
    delimiterLazyShow: true
  },
  shortDate: {
    date: true,
    datePattern: ['m', 'd']
  },
  standardDate: {
    date: true,
    datePattern: ['m', 'd', 'Y']
  },
  zip: {
    numericOnly: true,
    blocks: [5]
  },
  number: {
    numericOnly: true
  }
}
const placeholders = {
  shortDate:    'MM/DD',
  standardDate: 'MM/DD/YYYY'
}

const Container = styled.div`
  position: absolute;
  ${props => props.left ? `left: ${props.left}px;` : ''}
  ${props => props.right ? `right: ${props.right}px;` : ''}
  ${props => props.top ? `top: ${props.top}px;` : ''}
  ${props => props.bottom ? `bottom: ${props.bottom}px;` : ''}
`
// Normally I don't like to use !important, but we're working
// with bootstrap here so overriding is necessary :(

// Pass a stateless functional component to intercept the isValid prop and keep
// it from reaching the DOM (React doesn't like unknown props)
const CleaveInput = styled(({ isValid, ...rest }) => <Cleave {...rest} />)`
  border: 1px solid ${props => props.isValid ? '#ccd2d4' : 'red'} !important;
  border-radius: 4px;
  height: 13px !important;
  background: ${props => props.isValid ? '#add6eb' : '#f6ac99'} !important;
  padding: 2px !important;
  margin: 0 !important;
  font-size: 11px !important;
  width: ${props => props.width ? `${props.width}px` : 'auto'} !important;
  &:focused {
    border: 1px solid #39c;
  }
`
const Input = styled.input`
  border: 1px solid ${props => props.isValid ? '#ccd2d4' : 'red'} !important;
  border-radius: 4px;
  height: 13px !important;
  background: ${props => props.isValid ? '#add6eb' : '#f6ac99'} !important;
  padding: 2px !important;
  margin: 0 !important;
  font-size: 11px !important;
  width: ${props => props.width ? `${props.width}px` : 'auto'} !important;
  &:focused {
    border: 1px solid #39c;
  }
`
const Label = styled.label`
  font-size: 11px !important;
  margin: 0;
  height: 15px;
`

export default class TaxFormInput extends React.Component {
  static propTypes = {
    bottom:       PropTypes.number,
    className:    PropTypes.string,
    defaultValue: PropTypes.any,
    id:           PropTypes.string,
    inputRef:     PropTypes.func,
    label:        PropTypes.string,
    left:         PropTypes.number,
    onChange:     PropTypes.func.isRequired,
    required:     PropTypes.bool,
    right:        PropTypes.number,
    top:          PropTypes.number,
    type:         PropTypes.string,
    width:        PropTypes.number
  }
  constructor() {
    super()
    this.state = {
      isValid: true,
      isFocused: false
    }
  }
  onFocus = () => {
    this.setState({ isFocused: true })
  }
  validate = (value, type) => {
    this.setState({
      isValid: ValidationUtil.validate(value, type)
    })
  }
  onBlur = e => {
    const { type, required } = this.props
    if (required) {
      this.validate(e.target.value, type)
    }
    this.setState({ isFocused: false })
  }
  renderInput = () => {
    const { type, onChange, id, inputRef, width, defaultValue } = this.props
    const { isValid, isFocused } = this.state
    const commonProps = {
      onChange,
      isValid: isValid || isFocused,
      id,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      width
    }
    if (!types.includes(type)) {
      return (
        <Input
          ref={inputRef}
          defaultValue={defaultValue}
          {...commonProps}
        />
      )
    } else {
      return (
        <CleaveInput
          {...commonProps}
          options={cleaveOptions[type]}
          placeholder={placeholders[type]}
          htmlRef={inputRef}
        />
      )
    }
  }
  render() {
    const {
      id,
      label,
      left,
      right,
      top,
      bottom
    } = this.props
    return (
      <Container
        left={left}
        right={right}
        top={top}
        bottom={bottom}
      >
        <Label htmlFor={id}>{label}</Label>
        {this.renderInput()}
      </Container>
    )
  }
}
